import React, { useState } from "react";
import Input from "../../../components/Input";
import Button from "../../../components/Button";
import { useDispatch } from "react-redux";
import { login } from "../../../redux/actions/authActions";
import { useNavigate } from "react-router-dom";
import loginIcon from "../../../assets/images/loginIcon.png";

const Signup = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();


  const handleLogin = () => {
    if (email && password) {
      const user = { email }; // Simulate user data
      dispatch(login(user)); // Dispatch login action
      navigate("/"); // Redirect to dashboard
    }
  };

  return (
    <div className="flex h-screen bg-gray-50">
      {/* Left Side - Illustration */}
      <div className="w-1/2 flex items-center justify-center bg-white">
        <img
          src={loginIcon}
          alt="Illustration"
          className="w-3/4"
        />
      </div>

      {/* Right Side - Form */}
      <div className="w-1/2 flex items-center justify-center">
        <div className="w-2/3 bg-white p-8 rounded shadow-lg">
          {/* Title */}
          <div className="text-center mb-8">
            <h2 className="text-3xl font-semibold text-gray-800 mb-2">
              Sign Up
            </h2>
            <p className="text-sm text-gray-600">Let's build something great</p>
          </div>

          {/* Input Fields */}
          <Input
            label="E-mail or phone number"
            placeholder="Enter your email or phone"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Input
            label="Password"
            placeholder="Enter your password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          {/* Login Button */}
          <div className="mt-6">
            <button
              onClick={handleLogin}
              className="w-full bg-primary h-12 justify-center text-white py-3 rounded-md hover:bg-primary-dark transition text-center text-lg"
            >
              Login
            </button>
          </div>

          {/* Forgot Password */}
          <div className="flex justify-end mt-2">
            <a
              href="/forgot-password"
              className="text-sm text-primary hover:underline"
            >
              Forgot Password?
            </a>
          </div>

          {/* Google Button */}
          <div className="mt-6">
            <button
              onClick={() => alert("Google Sign-in")}
              className="w-full border bg-white py-2.5 rounded-md flex items-center justify-center shadow-sm hover:shadow-md"
            >
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/Google_%22G%22_Logo.svg/512px-Google_%22G%22_Logo.svg.png"
                alt="Google Logo"
                className="w-5 h-5 mr-2"
              />
              <span className="text-sm text-gray-700">Sign up with Google</span>
            </button>
          </div>

          {/* Footer */}
          <div className="text-center mt-6 text-gray-600">
            <span>Don’t have an account? </span>
            <a href="/signup" className="text-primary font-medium hover:underline">
              Sign up
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signup;
